var webinar = {
    title:"Marival Resorts Webinar",
    subtitle:"Get to know Marival Resorts with Marc Murphy.",
    unsupported:"Your browser does not support the video tag."
}
module.exports = webinar
